<template>
  <div class="user-add-container">
    <div class="back">
      <span @click="$router.go(-1)"><i class="iconfont icon-back"></i>返回</span>
    </div>
    <div class="content">
      <div class="title">TBOX版本升级</div>
      <div class="box">
        <div class="form"  >
          <el-form ref="form" :model="form" :rules='rules' label-width="160px">
            <el-row :gutter="5" style="text-align: left;margin-bottom: 10px;margin-left:58px">

            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="上传升级文件" prop="sn">
                <el-upload
                  class="upload-demo"
                  :action="URL+'/data/ftp/ftpupload'"
                  :headers="{'Authorization':'bearer' + token  }"
                  :on-preview="handlePreview"
                  :on-remove="handleRemove"
                  :file-list="fileList"
                  :on-success="successcall"
                  multiple>
                  <el-button size="small" type="primary">点击上传</el-button>
                  <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
                </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="版本号" prop="version">
                  <el-input v-model="form.version" disabled  placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="MD5" prop="md5" >
                  <el-input v-model="form.md5"  disabled  placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-form-item label="升级方式"  prop="type">
                 <el-radio-group v-model="form.type" @change = "checkedAction">
                    <el-radio :label="1">强制升级</el-radio>
                    <el-radio :label="2">判断升级版本</el-radio>
                    <el-radio :label="4">恢复上一版本</el-radio>
                  </el-radio-group>
               </el-form-item>
          </el-row>
          </el-form>
          <div class="btns">
            <el-button type="primary"   @click="submitForm('form')">提交</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { addTboxVersion } from '@/api/tboxUpgrade'
import { getToken } from '@/utils/auth'
export default {
  data() {
    return {
      fileList: [],
      token:getToken(),
      rules: {
        version: [
          { required: true, message: '版本号不能为空', trigger: 'change' }
        ],
        md5: [
          { required: true, message: 'MD5不能为空', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择输入方式', trigger: 'blur' }
        ]},
      form:{
        version:'',
        md5: '',
        fileName: ''
      },
      options: {
        factory: []
      },
      URL:process.env.VUE_APP_BASE_API
    }
  },
  created() {
      //this.sn = this.$route.query.sn
  },
  methods: {
    handleRemove(file, fileList) {
      console.log("555555555")
    },
    handlePreview(file) {
      console.log(file);
    },
    //Tbox_YTV171.00BDC6BA.bin
    successcall(res, file, fileList){
        let fileName = file.name
        if(res.code == 0 && fileName !=null && fileName !='' ){
              this.$message.success('上传成功!')
              this.fileList = fileList 
              this.form.version = fileName.substr(fileName.indexOf('V'),4)
              this.form.md5 = fileName.substr(fileName.indexOf('.')+1,8)
              this.form.fileName =fileName
        }else{
              this.handleRemove(file,fileList)
              this.$message.error(res.message)
        }
        
    },
    checkedAction(val){
      if(val == '4'){
          this.form.version = '0000'
          this.form.md5 = '00000000'
      }else{
        let fileSize =this.fileList.length
        if(fileSize > 0){
          let fileName = this.fileList[0].name
          this.form.version = fileName.substr(fileName.indexOf('V'),4)
          this.form.md5 = fileName.substr(fileName.indexOf('.')+1,8)
        }else{
          this.form.version = ''
          this.form.md5 = ''
        }
       
      }
    },
    // 提交表单
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.form.sn = this.$route.query.sn
          addTboxVersion(this.form).then(res=>{
            this.$message.success(res.message)
            this.$router.back(-1)
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.user-add-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px 20px;
  .back {
    color: #42a3df;
    font-size: 20px;
    font-weight: bold;
    padding-bottom: 10px;
    span {
      cursor: pointer;
    }
    .iconfont {
      margin-right: 10px;
    }
  }
  .content {
    flex: 1;
    min-height: 0;
    width: 100%;
    padding: 20px 20px;
    background: #fff;
    box-shadow: 0 0 6px 1px #acacac;
    overflow-y: auto;
    .title {
      font-size: 18px;
      line-height: 40px;
      font-weight: bold;
      color: #1f7eb8;
    }
    .box {
      display: flex;
      padding-top: 30px;
      .btns {
        padding: 30px 160px 60px;
      }
      .avatar {
        .img {
          padding: 30px 10px;
          border: 1px solid #bbb;
        }
      }
      .form {
        flex: 1;
        min-width: 0;
        max-width: 1100px;
      }
    }
  }
  #map-container {
    width: 100%;
    height: 400px;
    box-shadow: 0 0 10px 1px #acacac;
  }
}
</style>
<style lang="less">
.equipment-add-container {
  .el-form-item__label {
    color: #1a2550;
    padding: 0 30px 0 0;
  }
  .el-select,
  .el-input {
    width: 100%;
  }
}
.formedit{
  input::-webkit-input-placeholder { /* WebKit, Blink, Edge */
      color: #fff !important;
  }
  i{
    display: none;
  }
  .el-input.is-disabled .el-input__inner{
          cursor: auto;
        background-color: #fff;
        border:0;
  }
}

</style>
